import React from 'react';

/**
 * pencil-edit/pencil-edit-box from the New UI kit (Figma 1002:14717).
 */
interface PiPencilEditBoxStrokeProps extends React.SVGProps<SVGSVGElement> {
	size?: number;
	color?: string;
	className?: string;
	ariaLabel?: string;
}

export default function PiPencilEditBoxStroke({
	size = 16,
	color,
	className,
	ariaLabel = 'pencil-edit-box icon',
	...props
}: PiPencilEditBoxStrokeProps): JSX.Element {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			fill="none"
			stroke="currentColor"
			strokeWidth="1.39"
			strokeLinecap="round"
			strokeLinejoin="round"
			style={{ color: color || 'currentColor' }}
			role="img"
			aria-label={ariaLabel}
			{...props}
		>
			<path
				d="M13.3333 9.33333C13.3333 11.2002 13.3333 12.1336 12.97 12.8467C12.6505 13.4739 12.1405 13.9838 11.5133 14.3033C10.8003 14.6667 9.86687 14.6667 8 14.6667H6.66667C4.79983 14.6667 3.86641 14.6667 3.15337 14.3033C2.52616 13.9838 2.01622 13.4739 1.69665 12.8467C1.33333 12.1336 1.33333 11.2002 1.33333 9.33333V8C1.33333 6.13316 1.33333 5.19974 1.69665 4.4867C2.01622 3.85949 2.52616 3.34955 3.15337 3.02998C3.86641 2.66667 4.79983 2.66667 6.66667 2.66667M5.37437 9.001C5.38015 8.7672 5.38303 8.65027 5.4113 8.5404C5.43637 8.443 5.47606 8.35007 5.52902 8.26467C5.58875 8.1684 5.67109 8.08567 5.83577 7.92027L12.0999 1.62055C12.4247 1.2943 12.9321 1.23963 13.3184 1.48924C13.7764 1.78515 14.1677 2.174 14.4672 2.63082C14.484 2.65647 14.5013 2.68191 14.5174 2.70797C14.7679 3.11151 14.6862 3.62214 14.3573 3.95241L8.14247 10.2027C7.9716 10.3743 7.8862 10.4601 7.78653 10.5213C7.69813 10.5757 7.60173 10.6157 7.50093 10.6399C7.38727 10.6671 7.26647 10.667 7.02487 10.6666L5.33333 10.6639L5.37437 9.001Z"
				fill="none"
				stroke="currentColor"
				strokeWidth="1.39"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
